import { cloneElement } from 'react';

import { CoreIconProps } from '../shared/types/icon.types';

import IconLazy from './icon-lazy';
import styles from './icon.module.scss';

function CoreIcon(props: CoreIconProps) {
  const iconSizeClass = props.size ?? 'medium';
  const classesForIcon = `${styles['core-icon']} ${
    styles[`core-icon-${iconSizeClass}`]
  } ${props.appliedCssClassNames ? props.appliedCssClassNames : ''}`;

  if (props.name) {
    return (
      <IconLazy
        {...{
          name: props.name,
          ariaLabel: props.ariaLabel,
          ariaHidden: props.ariaHidden,
          className: classesForIcon,
        }}
      />
    );
  } else if (props.children) {
    return cloneElement(props.children as any, {
      'aria-label': props.ariaLabel,
      'aria-hidden': props.ariaHidden,
      className: classesForIcon,
    });
  } else {
    return null;
  }
}

export default CoreIcon;
